<c-modal #staticBackdropModal backdrop="static" size="lg" visible='true' id="staticBackdropModal">
    <c-modal-header>
        <h4 class="modal-title">{{ "Pet Check Ins Detail" }}</h4>
        <button [cModalToggle]="staticBackdropModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
    </c-modal-header>
    <c-modal-body *ngIf="isPetCheckInsDetailLoaded && petCheckInsDetail">
      <c-row [xs]="1" [xl]="2">
        <c-col>
          <c-card class="mb-4">
            <c-card-header>Pet</c-card-header>
            <c-card-body>
              <c-row>
                <c-col>
                  <c-row>
                    Name: {{petCheckInsDetail.name}}
                  </c-row>
                  <c-row>
                    Type: {{petCheckInsDetail.type.name}}
                  </c-row>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>
        </c-col>
        <c-col>
          <c-card class="mb-4">
            <c-card-header>Owner</c-card-header>
            <c-card-body>
              <c-row>
                <c-col>
                  <c-row>
                    Name: {{petCheckInsDetail.owner.firstName}} {{petCheckInsDetail.owner.lastName}}
                  </c-row>
                  <c-row>
                    Type: {{petCheckInsDetail.owner.type.name}}
                  </c-row>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
      <c-row [xs]="1" [xl]="1">
        <c-col>
          <c-card class="mb-4">
            <c-card-header>Check Ins List</c-card-header>
            <c-card-body>
              <c-row>
                <c-row>
                  <table cTable hover>
                    <thead>
                    <tr>
                      <th scope="col">Check In Date</th>
                      <th scope="col">Check In Services</th>
                      <th scope="col">Is Checked Out</th>
                      <th scope="col">Check Out Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let checkIn of petCheckInsDetail.checkIns;let i = index">
                      <td>{{checkIn.date | date: 'yyyy-MM-dd'}}</td>
                      <td><span *ngFor="let service of checkIn.services">{{service.name}}, </span></td>
                      <td>
                        <i *ngIf="checkIn.isCheckedOut" class="fa fa-check" aria-hidden="true"></i>
                        <i *ngIf="!checkIn.isCheckedOut" class="fa fa-xmark" aria-hidden="true"></i>
                      </td>
                      <td>{{checkIn.checkedOutDate | date: 'yyyy-MM-dd'}}</td>
                    </tr>
                    </tbody>
                  </table>
                </c-row>
              </c-row>
            </c-card-body>
          </c-card>
        </c-col>
      </c-row>
    </c-modal-body>
</c-modal>
